const doc = [({"da":({"js":({"users":({"edit":({"form":({"index":({"no_longer_in_school":"Jeg går ikke længere i skole"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;